import { IKnmReasonTypeSelectOption } from '../../../CorePackage/CatalogsModule/interfaces/IKnmReasonTypeSelectOption';
import { KnmReasonTypeNameEnum } from '../enums/KnmReasonTypeNameEnum';

export const isOneReasonLinkRequired = (reasonType: IKnmReasonTypeSelectOption | undefined): boolean => {
  return (
    !!reasonType &&
    (reasonType.name === KnmReasonTypeNameEnum.PRESCRIPTION_CHECK ||
      reasonType.name === KnmReasonTypeNameEnum.IMPOSSIBILITY_OF_PREVIOUS)
  );
};
